<template>
  <section class="hero" id="sl-hero">
    <div class="hero-body">
      <h1><fa-icon icon="grin-beam-sweat"/> Uh-oh.</h1>
      <p>That link didn't work... please go back and try again.</p>
      <button
        class="btn btn-primary"
        @click.prevent="$router.go(-1)">
        <fa-icon icon="arrow-left"/><span>&larr; Back</span>
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Missing',
  beforeRouteEnter (to, from, next) {
    next(self => {
      self.setPageMeta(to.meta)
    })
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/vars.scss";
  #sl-hero {
    height: calc(100vh - #{$navbar-height});
    padding: 0 0 0 0;
    justify-content: center;

    @media (min-width: $size-sm) {
      padding: 0 0 25% 10%;
    }
    @media (min-width: $size-md) {
      padding: 0 0 33% 15%;
    }
    @media (min-width: $size-lg) {
      padding: 0 0 15% 25%;
    }
  }
</style>
